"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "card-effect-box-row" };
const _hoisted_2 = {
    key: 0,
    class: "card-effect-box-content"
};
const _hoisted_3 = { class: "card-effect-box-content" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CardRenderItemComponent = (0, vue_1.resolveComponent)("CardRenderItemComponent");
    const _component_CardRenderSymbolComponent = (0, vue_1.resolveComponent)("CardRenderSymbolComponent");
    const _component_CardProductionBoxComponent = (0, vue_1.resolveComponent)("CardProductionBoxComponent");
    const _component_CardRenderTileComponent = (0, vue_1.resolveComponent)("CardRenderTileComponent");
    const _component_CardDescription = (0, vue_1.resolveComponent)("CardDescription");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        class: (0, vue_1.normalizeClass)(_ctx.getClasses())
    }, [
        (0, vue_1.createElementVNode)("div", _hoisted_1, [
            (_ctx.delimiter !== undefined && _ctx.cause !== undefined)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, [
                    ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.cause, (rowItem, rowIndex) => {
                        return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                            class: "card-effect-box-item",
                            key: rowIndex
                        }, [
                            (_ctx.isItem(rowItem))
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardRenderItemComponent, {
                                    key: 0,
                                    item: rowItem
                                }, null, 8, ["item"]))
                                : (_ctx.isSymbol(rowItem))
                                    ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardRenderSymbolComponent, {
                                        key: 1,
                                        item: rowItem
                                    }, null, 8, ["item"]))
                                    : (_ctx.isProductionBox(rowItem))
                                        ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardProductionBoxComponent, {
                                            key: 2,
                                            rows: rowItem.rows
                                        }, null, 8, ["rows"]))
                                        : (0, vue_1.createCommentVNode)("", true),
                            (_ctx.isTile(rowItem))
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardRenderTileComponent, {
                                    key: 3,
                                    item: rowItem
                                }, null, 8, ["item"]))
                                : (0, vue_1.createCommentVNode)("", true)
                        ]));
                    }), 128))
                ]))
                : (0, vue_1.createCommentVNode)("", true),
            (_ctx.delimiter !== undefined)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardRenderSymbolComponent, {
                    key: 1,
                    item: _ctx.delimiter
                }, null, 8, ["item"]))
                : (0, vue_1.createCommentVNode)("", true),
            (0, vue_1.createElementVNode)("div", _hoisted_3, [
                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.effect, (rowItem, rowIndex) => {
                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                        class: "card-effect-box-item",
                        key: rowIndex
                    }, [
                        (_ctx.isItem(rowItem))
                            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardRenderItemComponent, {
                                key: 0,
                                item: rowItem
                            }, null, 8, ["item"]))
                            : (_ctx.isSymbol(rowItem))
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardRenderSymbolComponent, {
                                    key: 1,
                                    item: rowItem
                                }, null, 8, ["item"]))
                                : (_ctx.isProductionBox(rowItem))
                                    ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardProductionBoxComponent, {
                                        key: 2,
                                        rows: rowItem.rows
                                    }, null, 8, ["rows"]))
                                    : (_ctx.isTile(rowItem))
                                        ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardRenderTileComponent, {
                                            key: 3,
                                            item: rowItem
                                        }, null, 8, ["item"]))
                                        : (0, vue_1.createCommentVNode)("", true)
                    ]));
                }), 128))
            ])
        ]),
        (_ctx.description)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardDescription, {
                key: 0,
                item: _ctx.description
            }, null, 8, ["item"]))
            : (0, vue_1.createCommentVNode)("", true)
    ], 2));
}
